let modules: any = {}
const modulesFile:any = import.meta.glob('./handler/*.ts',{eager:true});
for (const keyPath in modulesFile) {
    const moduleKey = keyPath.replace(/^\.\/handler\/(.*)\.ts$/, '$1')
    modules = {...modules,[moduleKey]:modulesFile[keyPath].default}
}



export const findErrorHandler=(errorName: string): any=> {
    let handler = modules[errorName];
    if (!handler) {
        handler = modules["DefaultException"];
    }
    return handler;
}

